var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.003,0 C39.0577727,0 39.918469,0.81457438 39.9945348,1.84795069 L40,1.997 L40,38.003 C40,39.0577727 39.1854256,39.918469 38.1520493,39.9945348 L38.003,40 L1.997,40 C0.942227273,40 0.0815309917,39.1854256 0.00546515778,38.1520493 L0,38.003 L0,1.997 C0,0.942227273 0.81457438,0.0815309917 1.84795069,0.00546515778 L1.997,0 L38.003,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.476,0.364 C8.583,0.953 8.64,1.566 8.64,2.205 C8.64,4.83083333 7.73812847,7.05991667 6.16498105,8.62028798 L5.956,8.82 L3.048,8.82 L3.048,6.561 C3.93292857,5.96857143 4.54280102,5.10453571 4.79274781,4.08338666 L4.844,3.845 L0,3.845 L0,0.364 L8.476,0.364 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.964,0.71 C4.672,2.837 6.656,4.42 9,4.42 C10.1100833,4.42 11.0689167,4.15195139 11.8418385,3.69133912 L12.048,3.561 L14.956,5.82 C13.467,7.194 11.43,8 9,8 C5.58547059,8 2.61746886,6.09990225 1.09170499,3.29907427 L0.957,3.042 L0.957,0.71 L3.964,0.71 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.964,0.958 L3.964,3.29 C3.784,3.83 3.682,4.407 3.682,5 C3.682,5.49416667 3.75283333,5.97722222 3.88061111,6.43701389 L3.964,6.71 L0.957,9.042 C0.348,7.827 0,6.452 0,5 C0,3.669 0.292416667,2.40270139 0.810237847,1.2650353 L0.957,0.958 L3.964,0.958 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C11.3104762,0 13.2681179,0.809070295 14.7960436,2.1404168 L15.022,2.344 L12.44,4.925 C11.508,4.034 10.321,3.58 9,3.58 C6.73413333,3.58 4.80466667,5.05922556 4.03901941,7.07915181 L3.964,7.29 L0.957,4.958 C2.438,2.017 5.482,0 9,0 Z",
    id: "path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-in-/-google",
    transform: "translate(-750.000000, -655.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(748.000000, 653.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-0.06 40 40.02 40 40.02 -0.08 -0.06 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#318AF5",
    mask: "url(#mask-4)",
    points: "-0.02 8.92 8.74 8.92 8.74 0.28 -0.02 0.28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#3DA751",
    mask: "url(#mask-6)",
    points: "0.94 8.08 14.98 8.08 14.98 0.64 0.94 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(11.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FDB900",
    mask: "url(#mask-8)",
    points: "-0.02 9.16 4.06 9.16 4.06 0.88 -0.02 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#EA3E36",
    mask: "url(#mask-10)",
    points: "0.94 7.4 15.1 7.4 15.1 -0.04 0.94 -0.04"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.efa22d835067b59a6ca859cc693ab475.svg";
export { ForwardRef as ReactComponent };